export default "__VITE_PUBLIC_ASSET__cc49ac69__"